<div *ngIf="type==='inlineDialog' && fundraiser?.raised?.backers" class="wrap">
  <div class="inlineCount">
    <div class="left">
      <img loading="lazy" class="fr-spporters-img" [attr.data-src]="supporterImg" alt="all supporters" />
      <div *ngIf="!isMobile" class="text">
        <div class="count">{{fundraiser?.raised?.backers|donorCountFormat}}</div>
        <div class="label">Supporters</div>
      </div>
      <div *ngIf="isMobile" class="text" (click)="openViewSupporters()">
        <div class="countLabel">View all {{fundraiser?.raised?.backers|donorCountFormat}} supporters</div>
        <em class="material-icons">arrow_forward</em>
      </div>
    </div>
    <div *ngIf="!isMobile" class="right">
      <button class="commonBtn viewAll" (click)="openViewSupporters()">View All</button>
    </div>
  </div>
</div>

<div *ngIf="type==='onpage' && fundraiser?.raised?.backers" class="onPageWrap">
  <ng-container *ngTemplateOutlet="viewSupportersTemp" />
</div>

<app-signin-signup *ngIf="loginPopupState" [showPopup]="loginPopupState" [popupView]="true" [numberOnly]="true" [noRedirectAfterLogin]="true" (onClose)="signinClosed($event)" />

<ng-template #viewSupportersTemp>
  <div *ngIf="type==='inlineDialog' && isMobile" class="closeBar" (click)="closeSupporter()" mat-ripple></div>
  <button *ngIf="type==='inlineDialog' && !isMobile" class="closeBtn" (click)="closeSupporter()" mat-ripple><em class="material-icons">close</em></button>
  <div class="allSupporters">
    <div class="head">
      <mat-icon class="icon-users" />
      <div class="title">{{fundraiser?.raised?.backers|donorCountFormat}} supporters</div>
    </div>
    <div class="headLine"></div>
    <div *ngIf="!isLoggedIn && loginMandate" class="loginLayer">
      <div class="title">Sign in to meet those driving everyday change.</div>
      <button class="commonBtn loginBtn" (click)="openLoginPopup()" mat-ripple>Sign in <em class="material-icons">arrow_forward</em></button>
      <ng-container *ngTemplateOutlet="dummySupportersTemp" />
    </div>
    <div *ngIf="myDonations?.length && !(!isLoggedIn && loginMandate)" class="myDonations">
      <div class="heading"><em class="material-icons">person_outline</em><div class="title">Your Donations</div></div>
      <div *ngFor="let item of myDonations" class="donation">
        <div class="left">
          <div class="name" [innerHTML]="item?.name"></div>
        </div>
        <div class="right">
          <app-currency [currency]="item?.iso_currency" /><div class="amount">{{item?.donated_amount_local}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!(!isLoggedIn && loginMandate)" class="visibleSupporters">
      <div *ngIf="unauthoriseDonor" class="unauthorizeLayer">
        <span>Only supporters of this fundraiser can view more supporters.</span>
      </div>
      <ng-container *ngIf="loading; else supporterList">
        <div *ngFor="let _ of skeletons" class="supporter"><div class="left"><div class="logo skeleton"></div><div class="name"></div></div><div class="right skeleton"></div></div>
      </ng-container>
      <div *ngIf="myDonations?.length" class="findDonation" (click)="findDonation()">Can’t find your donation? <button class="commonBtn">Click here</button></div>
      <div  class="pagination">
        <em class="material-icons" [class.disable]="!pageData?.prev_page_url" (click)="previousPage()" mat-ripple>chevron_left</em>
        <span>{{pageData?.from}} - {{pageData?.to}} of {{fundraiser?.raised?.backers}} donations</span>
        <em class="material-icons" [class.disable]="!pageData?.next_page_url" (click)="nextPage()" mat-ripple>chevron_right</em>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #supporterList>
  <div *ngFor="let item of visibleSupporters" class="supporter">
    <div class="left">
      <div class="logo">
        <mat-icon *ngIf="item?.is_anonymous" class="icon-user" />
        <img *ngIf="item?.cdn_image && !item?.is_anonymous" src="{{item.cdn_image}}" alt="item?.name">
        <span *ngIf="!item?.cdn_image && !item?.is_anonymous">{{item?.name | nameInitials}}</span>
      </div>
      <div class="name" [innerHTML]="item?.name"></div>
    </div>
    <div class="right">
      <app-currency [currency]="item?.iso_currency" /><div class="amount">{{item?.donated_amount_local}}</div>
    </div>
  </div>
</ng-template>

<ng-template #dummySupportersTemp>
  <div class="visibleSupporters">
    <div *ngFor="let item of dummyVisibleSupporters" class="supporter">
      <div class="backDrop"></div>
      <div class="left">
        <div class="logo">
          <span>{{item?.name | nameInitials}}</span>
        </div>
        <div class="name" [innerHTML]="item?.name"></div>
      </div>
      <div class="right">
        <app-currency [currency]="item?.iso_currency" /><div class="amount">{{item?.donated_amount_local}}</div>
      </div>
    </div>
  </div>
</ng-template>
